<template>
    <div v-if="dailyBriefing">
        <header class="bg-gray-100 text-gray-700">
            <div class="w-full mx-auto p-8 lg:p-12 flex flex-col md:flex-row-reverse" style="max-width: 1800px">
                <div class="md:w-72 mb-12 md:mb-0 md:ml-8 lg:ml-12">
                    <img src="https://insync.software/mobile-img/logo.svg" class="h-12">
                    <div class="mt-4">
                        <p class="font-semibold mb-1">Hambro Roofing Limited</p>
                        <p>Unit 2, 6-10 Lamson Road Rainham Essex RM13 9YY</p>
                        <p><a href="tel:01708803930">01708 803 930</a></p>
                        <p><a href="http://www.hambroroofing.com">www.hambroroofing.com</a></p>
                    </div>
                </div>
                <div class="flex-1">
                    <div class="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-8">
                        <div class="text-xl">
                            <h2 class="font-semibold text-gray-700">Date:</h2>
                            <p class="mt-1 text-gray-500">{{ dailyBriefing.formattedDate }}</p>
                        </div>
                        <div class="text-xl">
                            <h2 class="font-semibold text-gray-700">Package:</h2>
                            <p class="mt-1 text-gray-500">{{ dailyBriefing.packageName }}</p>
                        </div>
                        <div class="text-xl col-span-1 sm:grid-cols-2">
                            <h2 class="font-semibold text-gray-700">Daily Briefing reference:</h2>
                            <p class="mt-1 text-gray-500">{{ dailyBriefing.dailyBriefingId }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main class="bg-white text-gray-700">
            <div class="w-full mx-auto p-8 lg:p-12 pb-16 lg:pb-16 flex flex-col-reverse lg:flex-row-reverse"
                 style="max-width: 1800px">
                <div class="lg:w-72 mb-12 lg:mb-0 lg:ml-12 ">
                    <div class="space-y-8 sticky top-4">
                    </div>
                </div>
                <div class="flex-1">
                    <div class="text-xl font-semibold text-gray-900 mt-4">Location of Works</div>
                    <div class="text-gray-700 whitespace-pre-wrap" v-text="dailyBriefing.locationOfWorks"></div>
                    <div class="text-xl font-semibold text-gray-900 mt-4">Key Activities</div>
                    <div class="text-gray-700 whitespace-pre-wrap" v-text="dailyBriefing.keyActivites"></div>
                    <div class="text-xl font-semibold text-gray-900 mt-4">Key Hazards</div>
                    <div class="text-gray-700 whitespace-pre-wrap" v-text="dailyBriefing.keyHazards"></div>
                    <div class="text-xl font-semibold text-gray-900 mt-4"
                         v-if="dailyBriefing.attendees && dailyBriefing.attendees.length">Attendee's
                    </div>
                    <div class="text-gray-700" v-if="dailyBriefing.attendees && dailyBriefing.attendees.length">
                        <table style="width:100%; border-collapse: collapse;margin-top:10px;">
                            <tr>
                                <td class="border border-gray-400 px-2 py-1 bg-gray-50" style="width:47%">
                                    <strong>Name</strong>
                                </td>
                                <td class="border border-gray-400 px-2 py-1 bg-gray-50" style="width:47%">
                                    <strong>Position</strong>
                                </td>
                                <td class="border border-gray-400 px-2 py-1 bg-gray-50" style="width:6%">
                                    <strong>Signature</strong>
                                </td>
                            </tr>
                            <tr v-for="attendee in dailyBriefing.attendees">
                                <td class="border border-gray-400 px-2 py-1">
                                    {{ attendee.name }}
                                </td>
                                <td class="border border-gray-400 px-2 py-1">
                                    {{ attendee.position }}
                                </td>
                                <td class="border border-gray-400 px-2 py-0">
                                    <img :src="attendee.signature" v-if="attendee.signature"
                                         style="width:100%; margin-top:1px; padding:0px">
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="text-xl font-semibold text-gray-900 mt-4">Given By</div>
                    <div class="text-gray-700 whitespace-pre-wrap" v-text="dailyBriefing.givenByName+' ('+dailyBriefing.givenByPosition+')'"></div>
                    <div class="text-xl font-semibold text-gray-900 mt-4">Signed</div>
                    <img v-if="dailyBriefing.signature" :src="dailyBriefing.signature"
                         style="width:100%; margin: 5px; max-width: 350px">
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import {ExternalDailyBriefing} from '@models'
import UiDropdown from "../../../ui/UiDropdown.vue";
import UiTextarea from "../../../ui/UiTextarea.vue";
import UiDropdownItem from "../../../ui/UiDropdownItem.vue";
import UiDataGrid from "../../../ui/UiDataGrid.vue";
import UiDataGridItem from "../../../ui/UiDataGridItem.vue";

export default {
    components: {UiDataGridItem, UiDataGrid, UiDropdownItem, UiTextarea, UiDropdown},
    props: {
        id: null | String,
    },
    data() {
        return {
            dailyBriefing: null,
        }
    },
    computed: {},
    methods: {
    },
    async mounted() {
        if (this.id) {
            this.dailyBriefing = await ExternalDailyBriefing.find(this.id);
        }
    },
}
</script>
